/* eslint-disable */
// FIXME 该文件 lint 修复时，改动过大暂时关闭 eslint 检查，建议重构优化

/**
 * 前端公用方法
 * @description 新增的方法不再放在util对象，而是采用ESMoudle的export导出，便于treeSharking
*/
import Cookies from "js-cookie";
import axios from './axios';
import 'isomorphic-fetch';
import { COURSE_TYPE } from '../../constant/constant';
import nativeProxy from '@nativeApp/nativeProxy';

const util = {};

/**
 * 获取用户的登录状态
 * @param {boolean} forceCheck 强制执行查询登录状态
 */
util.isLogin = function (forceCheck = false) { // 使用 function 保存 this
  return new Promise(resolve => {
    if (!forceCheck && !!this.hasCheckIsLogin) {
      resolve(this.loginStatus);
      return;
    }

    this.checkLogin(() => {
      this.hasCheckIsLogin = true;
      this.loginStatus = true;
      resolve(true);
    }, () => {
      this.hasCheckIsLogin = true;
      this.loginStatus = false;
      resolve(false);
    });
  })
};

/**
 * 判断是否登录
 * @param {function} successCallback 成功的回调
 * @param {function} failCallback 失败的回调
 */
util.checkLogin = async (successCallback = (() => { }), failCallback = (() => { })) => {
  if (!window.sucCallbackList || Object.prototype.toString.call(window.sucCallbackList) != "[object Array]") {
    window.sucCallbackList = [];
  }
  if (!window.failCallbackList || Object.prototype.toString.call(window.failCallbackList) != "[object Array]") {
    window.failCallbackList = [];
  }

  if (successCallback && typeof successCallback === 'function') {
    window.sucCallbackList.push(successCallback);
  }
  if (failCallback && typeof failCallback === 'function') {
    window.failCallbackList.push(failCallback);
  }

  try {
    // 获取 UserInfo 的请求l
    let UserInfo = {};
    const isLogin = Cookies.get('isLogin');
    if (isLogin === 'true') {
      const { user_info, statusCode } = await axios.get('/getUserInfo');
      if (statusCode === 40105) { // 退出登录，让统一登录清除失效的 ticket 和 token
        location.href = `${window.__INITIAL_STATE__.logoutUrl}?redirect_url=${encodeURIComponent(location.href)}`;
        return;
      }
      UserInfo = user_info;
    }
    if (UserInfo && JSON.stringify(UserInfo) !== '{}') { // 获取成功
      window.UserInfo = UserInfo;
      Cookies.set("userId", UserInfo.resourceid, { path: '/' });
      Cookies.set("stageName", UserInfo.stageName, { path: '/' });
      Cookies.set("stageId", UserInfo.stageId, { path: '/' });
      Cookies.set("subjectName", UserInfo.subjectName, { path: '/' });
      Cookies.set("subjectId", UserInfo.subjectId, { path: '/' });
      Cookies.set("isLogin", UserInfo.token ? true : false, { expires: 30, secure: true });
      axios.get('/addCookie', {
        params: {
          token: UserInfo.token
        }
      }).then(() => {
        if (window.sucCallbackList.length > 0) {
          var curFun = window.sucCallbackList[0];
          window.sucCallbackList.shift();
          curFun();
        }
      }).catch((error) => {
        console.error('add cookie fail:', error);
      });
    } else { // 获取失败
      if (window.failCallbackList.length > 0) {
        var curFun = window.failCallbackList[0];
        window.failCallbackList.shift();
        curFun();
      }
      Cookies.set("isLogin", false, { path: '/' });
      axios.get('/removeCookie').catch((error) => {
        console.error('remove cookie fail:', error);
      })
    }
  } catch (err) {
    console.log('获取 UserInfo 失败：', err);
  }
}

util.addLoginFrame = (src) => {
  const getIframe = () => {
    const dom = document.createElement('div');
    dom.id = 'loginIframe';
    dom.style = 'position: fixed;left: 50%;top: 50%;margin-left: -170px;margin-top: -207.5px;z-index: 1003;';
    dom.innerHTML = '<a class="iframe-close-btn"></a>' +
      '<iframe style="min-height: 415px; background: #FFF;" src=' + src +
      ' frameborder="0" width="340"></iframe>';
    return dom;
  }

  const getLoginCover = () => {
    const dom = document.createElement('div');
    dom.id = "login-cover";
    var winHeight = document.body.offsetHeight;
    dom.style.height = winHeight;
    return dom;
  }

  const loginIframe = getIframe();


  document.querySelector('body').appendChild(loginIframe);
  if (!document.querySelector("#login-cover")) {
    const cover = getLoginCover();
    document.querySelector("#app").appendChild(cover);
  } else {
    document.querySelector("#login-cover").style.display = 'block';
  }
}

util.inframeLogin = () => {
  if (util.getBrowser() === "ie" || util.getBrowser() === "firefox" || util.getBrowser() === "safari") {
    window.location.href = window.__INITIAL_STATE__.loginUrl_pc;
  } else {
    if (!document.querySelector('#loginIframe')) {
      const baseUrl = window.location.protocol + "//" + window.location.host;
      const channel = Cookies.get('channel') ? Cookies.get('channel') : '';
      const src = window.__INITIAL_STATE__.loginIframeUrl + "?system=SeewoeduTrain&channel=" + channel + "&callbackIframeUrl=" + encodeURIComponent(baseUrl + "/redirect") + "&redirect_url=" + encodeURIComponent(window.location.href);
      util.addLoginFrame(src);
    }
  }
}

util.inframeRegister = (dataReport) => {
  if (util.getBrowser() === "ie" || util.getBrowser() === "firefox" || util.getBrowser() === "safari") {
    const channel = Cookies.get('channel') ? Cookies.get('channel') : '';

    const redirectPc_url = `${'&channel=' + channel + '&actionType=register' + '&registUrl=' + encodeURIComponent(location.protocol + '//' + location.host + '/redirect?')}`;
    window.location.href = `${window.__INITIAL_STATE__.Config.loginUrl_pc + redirectPc_url}${encodeURIComponent('&redirect_url=' + encodeURIComponent(window.location.pathname))}`;
  } else {
    if (!document.querySelector('#loginIframe')) {
      const channel = Cookies.get('channel') ? Cookies.get('channel') : '';
      const baseUrl = window.location.protocol + "//" + window.location.host;
      const src = window.__INITIAL_STATE__.loginIframeUrl + "?system=SeewoeduTrain&actionType=register&channel=" + channel + "&callbackIframeUrl=" + encodeURIComponent(baseUrl + "/redirect") + "&redirect_url=" + encodeURIComponent(window.location.href) + "&dataReport=" + encodeURIComponent(dataReport);
      util.addLoginFrame(src);
    }
  }
}

util.cstoreImgThumbnail = (url, size) => {
  if (url && size) {
    if (/\?imageMogr2/.test(url)) {
      url = url + `/thumbnail/${size}`;
    } else {
      if (!/\?/.test(url)) {
        url = url + `?imageMogr2/thumbnail/${size}`;
      }
    }
  }
  return url;
}

// 图片瘦身
util.cstoreImagesStrip = (url) => {
  // 对于无参数的链接，添加?imageMogr2/strip
  if (!/\?/.test(url)) {
    url = url + `?imageMogr2/strip`;
  }
  return url;
}
/**
 * 分享初始化
 * @param title 
 * @param imgUrl
 * @param desc
 * @param url
 */
util.initWeChat = (title, imgUrl, desc, url) => {
  const ua = window.navigator.userAgent.toLowerCase();
  if (!(/mobile/i.test(ua))) { return; }

  title = title ? title : "希沃学苑：一线教师专属信息化教育培训平台";
  imgUrl = imgUrl ? imgUrl : window.__INITIAL_STATE__.seewoEduUrl + '/statics/global/images/logo.png';
  desc = desc ? desc.trim().substring(0, 50) : "超20000节精彩案例，与百万老师共同学习。";
  url = url ? url : window.location.href;

  fetch('/m/wechatSign?url=' + encodeURIComponent(window.location.href))
    .then(function (response) {
      return response.json();
    }).then(function (data) {
      if (data.statusCode == 200) {
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.ts, // 必填，生成签名的时间戳
          nonceStr: data.noStr, // 必填，生成签名的随机串
          signature: data.sign, // 必填，签名，见附录1
          jsApiList: [
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareQZone'
          ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });

        wx.ready(function () {
          wx.onMenuShareTimeline({
            title: title, // 分享标题
            link: util.getUrlWithParam(url, 'channel', 'wechat_moments'), // 分享链接
            imgUrl: imgUrl, // 分享图标
            success: function () {
              if (window.wechatShareSuccessCallback) {
                window.wechatShareSuccessCallback();
              }
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
              if (window.cancelWechatShareCallback) {
                window.cancelWechatShareCallback();
              }
            },
            trigger: function () {
              // 用户触发分享s
              if (window.triggerShareCallback) {
                window.triggerShareCallback();
              }
            },
          });

          wx.onMenuShareAppMessage({
            title: title, // 分享标题
            desc: desc, // 分享描述
            link: util.getUrlWithParam(url, 'channel', 'wechat_chat'), // 分享链接
            imgUrl: imgUrl, // 分享图标
            type: 'link', // 分享类型,music、video或link，不填默认为link
            dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
            success: function () {
              if (window.wechatShareSuccessCallback) {
                window.wechatShareSuccessCallback();
              }
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
              if (window.cancelWechatShareCallback) {
                window.cancelWechatShareCallback();
              }
            },
            trigger: function () {
              // 用户触发分享
              if (window.triggerShareCallback) {
                window.triggerShareCallback();
              }
            },
          });

          wx.onMenuShareQQ({
            title: title, // 分享标题
            desc: desc, // 分享描述
            link: url, // 分享链接
            imgUrl: imgUrl, // 分享图标
            success: function () {
              if (window.wechatShareSuccessCallback) {
                window.wechatShareSuccessCallback();
              }
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
              if (window.cancelWechatShareCallback) {
                window.cancelWechatShareCallback();
              }
            },
            trigger: function () {
              // 用户触发分享
              if (window.triggerShareCallback) {
                window.triggerShareCallback();
              }
            },
          });

          wx.onMenuShareQZone({
            title: title, // 分享标题
            desc: desc, // 分享描述
            link: url, // 分享链接
            imgUrl: imgUrl, // 分享图标
            success: function () {
              if (window.wechatShareSuccessCallback) {
                window.wechatShareSuccessCallback();
              }
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
              if (window.cancelWechatShareCallback) {
                window.cancelWechatShareCallback();
              }
            },
            trigger: function () {
              // 用户触发分享
              if (window.triggerShareCallback) {
                window.triggerShareCallback();
              }
            },
          });
        });
      } else {
        setTimeout(function () {
          util.initWeChat(title, imgUrl, desc, url);
        }, 3000);
      }
    }).catch(function (e) {
      console.error("shareError", e);
    });

  // window.initWechatJS = initWechatJS;
}

const isShareVideoChannel = (channel) =>
  typeof channel === 'string' &&
  (channel === 'XSC' ||
    channel === 'AIal' ||
    channel === 'AIHW' ||
    channel.startsWith('AIstudy'));

// 初始化课程分享
util.initShareCourse = (groupId) => {
  const requestReport = () => {
    if (!isShareVideoChannel(util.getUrlParam('channel'))) return;
    axios.post('/v1/tasks/finished', {
      type: 'shareVideo',
      extraUid: groupId,
    });
  }

  if (nativeProxy.isInApp()) {
    nativeProxy.inject({
      name: 'wShareClick',
      func: () => {
        requestReport();
        // 用户触发分享
        if (window.triggerShareCallback) {
          window.triggerShareCallback();
        }
      },
    });
  } else {
    window.wechatShareSuccessCallback = requestReport;
  }
}

/**
 * 获取当前body滚动高度
 * @returns UserInfo
 */
util.getBodyScrollTop = () => {
  return document.documentElement.scrollTop + document.body.scrollTop;
};

util.formatUserPhotoUrl = (photoUrl, phone) => {
  if (!photoUrl || photoUrl == "null") {
    var lastNum = phone ? Number(phone.substr(phone.length - 1)) : 1;
    var avatarName = lastNum ? "0" + lastNum + ".png" : "10.png";
    photoUrl = 'https://o1aa0tynl.qnssl.com/avatar/' + avatarName;
  }
  return photoUrl;
}

util.encryptStrWithStar = (str) => {
  if (str && str.length > 0) {
    var l = Math.floor(str.length / 3);
    var head = str.substring(0, l);
    var tail = str.substr(-l);
    var star = '';
    for (var i = 0; i < str.length - 2 * l; i++) {
      star += "*";
    }
    return head + star + tail;
  }
  return '';

}

/**
 * 获取URL中的查询参数的值
 * @method  SC.util.getUrlParam
 * @param {string} paras 参数key
 * @param {string} parseUrl 指定解析的 url
 * @returns {string} 返回参数的value
 */
util.getUrlParam = (paras, parseUrl) => {
  var url = parseUrl || location.href.split('#')[0];
  var paraString = url.substring(url.indexOf("?") + 1, url.length).split("&");
  var paraObj = {}
  var j;
  for (var i = 0; j = paraString[i]; i++) {
    paraObj[j.substring(0, j.indexOf("=")).toLowerCase()] = j.substring(j.indexOf("=") + 1, j.length);
  }
  var returnValue = paraObj[paras.toLowerCase()];
  if (typeof (returnValue) === "undefined") {
    return "";
  }
  return returnValue;

};

//字符串 转json
util.stringToJson = (value) => {
  try {
    var qrObj = JSON.parse(value);
  } catch (err) {
    return {};
  }
  return qrObj;
};

//json 转字符串
util.jsonToString = (obj) => {
  try {
    var objStr = JSON.stringify(obj);
  } catch (err) {
    return '';
  }
  return objStr;
};

/**
   * 时间格式化 返回格式化的时间
   * 格式：
   *    YYYY：4位年,如1993
   *　　YY：2位年,如93
   *　　MM：月份
   *　　DD：日期
   *　　hh：小时
   *　　mm：分钟
   *　　ss：秒钟
   *　　星期：星期，返回如 星期二
   *　　周：返回如 周二
   *　　week：英文星期全称，返回如 Saturday
   *　　www：三位英文星期，返回如 Sat
   * @method SC.util.formatDate
   * @param {object} date   可选参数，要格式化的data对象，没有则为当前时间
   * @param {string} fomat  格式化字符串，例如：'YYYY年MM月DD日 hh时mm分ss秒 星期' 'YYYY/MM/DD week' (中文为星期，英文为week)
   * @return {string} 返回格式化的字符串
   *
   * 例子:
   * @example
   *   formatDate(new Date("january 01,2012"));
   * @example
   *   formatDate(new Date());
   * @example
   *   formatDate('YYYY年MM月DD日 hh时mm分ss秒 星期 YYYY-MM-DD week');
   * @example
   *   formatDate(new Date("january 01,2012"),'YYYY年MM月DD日 hh时mm分ss秒 星期 YYYY/MM/DD week');
   */
util.formatDate = (date, format) => {
  var week = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', '星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
  return format.replace(/YYYY|YY|MM|DD|hh|mm|ss|www|week/g, function (a) {
    switch (a) {
      case "YYYY":
        return date.getFullYear();
      case "YY":
        return (date.getFullYear() + "").slice(2);
      case "MM":
        return (date.getMonth() + 1 + "").length < 2 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
      case "DD":
        return (date.getDate() + "").length < 2 ? "0" + date.getDate() : date.getDate();
      case "hh":
        return (date.getHours() + "").length < 2 ? "0" + date.getHours() : date.getHours();
      case "mm":
        return (date.getMinutes() + "").length < 2 ? "0" + date.getMinutes() : date.getMinutes();
      case "ss":
        return (date.getSeconds() + "").length < 2 ? "0" + date.getSeconds() : date.getSeconds();
      case "星期":
        return "星期" + week[date.getDay() + 7];
      case "week":
        return week[date.getDay()];
      case "www":
        return week[date.getDay()].slice(0, 3);
      default:
        return '';
    }
  });
};

/* 
  计算距离今天的时间差
  日为单位，今天，昨天，前天
  超过 返回 xx 月 xx 日
  超过一年 返回 xxxx 年 xx 月 xx 日
*/
util.distanceToday = (date) => {
  const data = util.formatDate(new Date(date), 'YYYY年MM月DD日');
  const today = util.formatDate(new Date(), 'YYYY年MM月DD日');
  if (data.substring(0, 4) !== today.substring(0, 4)) {
    return data;
  } else if (data.substring(5, 7) !== today.substring(5, 7)) {
    return data.substring(5);
  } else if (data.substring(8, 10) !== today.substring(8, 10)) {
    const data_Day = parseInt(data.substring(8, 10));
    const today_Day = parseInt(today.substring(8, 10));
    if (today_Day - 1 === data_Day) {
      return "昨天";
    } else if (today_Day - 2 === data_Day) {
      return "前天";
    }
    return data.substring(5);
  }
  return "今天";
}

/* 判断是否是今天 */
util.isToday = (str) => {
  const time = parseInt(str);
  if (new Date(time).toDateString() === new Date().toDateString()) {
    return true;
  }
  return false;

}

/* 判断是否是今年 */
util.isToYear = (str) => {
  const time = parseInt(str);
  if (new Date(time).getFullYear() === new Date().getFullYear()) {
    return true;
  }
  return false;

}

/* 
  根本用不到亿的方法，完全不知道写的意义是啥
*/
util.parseFloat2mil = (num) => {
  let number = parseInt(num || 0);
  if (number < 10000) {
    return number;
  } else if (number < 100000000) {
    number = number / 10000;
    // if (parseInt(number) === number) {
    //   return parseInt(number) + "万"
    // }
    return number.toFixed(1) + "万";

  }
  number = number / 100000000;
  // if (parseInt(number) === number) {
  //   return parseInt(number) + "亿"
  // }
  return number.toFixed(1) + "亿";


}

// 获取当前 dom index
util.getCurDomIndex = (element) => {
  return Array.prototype.slice.call(element.parentNode.children).indexOf(element);
}

// TODO 干掉这个函数
util.getGroupPrice = (groupInfo) => {

  return {
    currentPrice: 0,
    sPrice: 0,
  }
}

// 获取浏览器类型
util.getBrowser = (getVersion) => {
  var ua_str = navigator.userAgent.toLowerCase(), ie_Tridents, trident, match_str, ie_aer_rv, browser_chi_Type;
  //判断IE 浏览器
  if ("ActiveXObject" in window) {
    ie_aer_rv = (match_str = ua_str.match(/msie ([\d.]+)/)) ? match_str[1] :
      (match_str = ua_str.match(/rv:([\d.]+)/)) ? match_str[1] : 0;

    // ie: Indicate the really version of current IE browser.
    ie_Tridents = { "trident/7.0": 11, "trident/6.0": 10, "trident/5.0": 9, "trident/4.0": 8 };
    //匹配 ie8, ie11, edge
    trident = (match_str = ua_str.match(/(trident\/[\d.]+|edge\/[\d.]+)/)) ? match_str[1] : undefined;
    browser_chi_Type = (ie_Tridents[trident] || ie_aer_rv) > 0 ? "ie" : undefined;
  } else {
    //若要返回 "edge" 请把下行的 "ie" 换成 "edge"。 注意引号及冒号是英文状态下输入的
    browser_chi_Type = (match_str = ua_str.match(/edge\/([\d.]+)/)) ? "ie" :
      //判断firefox 浏览器
      (match_str = ua_str.match(/firefox\/([\d.]+)/)) ? "firefox" :
        //判断chrome 浏览器
        (match_str = ua_str.match(/chrome\/([\d.]+)/)) ? "chrome" :
          //判断opera 浏览器
          (match_str = ua_str.match(/opera.([\d.]+)/)) ? "opera" :
            //判断safari 浏览器
            (match_str = ua_str.match(/version\/([\d.]+).*safari/)) ? "safari" : undefined;
  }

  //返回浏览器类型和版本号
  var verNum, verStr;
  verNum = trident && ie_Tridents[trident] ? ie_Tridents[trident] : match_str[1];

  verStr = (getVersion != undefined) ? browser_chi_Type + "/" + verNum : browser_chi_Type;
  return verStr;
}

/**
 * 前端检测图片有效性
 * @param imgUrl
 */
util.checkImgValid = (url) => {
  if (!url) { return false; }
  var ImgObj = new Image();
  ImgObj.src = url;
  if (ImgObj.fileSize > 0 || (ImgObj.width > 0 && ImgObj.height > 0)) {
    return true;
  }
  return false;

}



/**
 * 数字千分位分割
 * @param num
 * @returns {string}
 */
util.toThousands = (num) => {
  function format(num) {
    let result = '';
    while (num.length > 3) {
      result = ',' + num.slice(-3) + result;
      num = num.slice(0, num.length - 3);
    }
    if (num) { result = num + result; }
    return result;
  }

  num = (num || 0).toString();
  let result = '';
  if (num.indexOf('.') !== -1) {
    const tmpArr = num.split('.');
    return `${format(tmpArr[0])}.${format(tmpArr[1])}`;
  }
  return format(num);
}
/**
 * 格式化链接
 */
util.formaterUrl = (url) => {
  if (!/^(http:\/\/|https:\/\/)/.test(url)) {
    return `http://${url}`;
  }
  return url;
};

/**
 * 只调用一次
 */
util.callOnce = (fn) => {
  let result;
  return () => {
    if (fn) {
      result = fn.apply(this, arguments);
      fn = null;
    }
    return result;
  };
};

/**
 * 替换对象属性名
 */
util.replaceObprop = (ob, srcProp, desProp) => {
  if (typeof ob !== 'object') {
    throw new Error('The paramter "object" is illegal');
  }

  if (typeof srcProp !== 'string') {
    throw new Error('The paramter "srcProp" is illegal');
  }

  if (typeof desProp !== 'string') {
    throw new Error('The paramter "desProp" is illegal');
  }

  const reg = new RegExp(`"${srcProp}":`, 'g');
  const res = JSON.stringify(ob).replace(reg, `"${desProp}":`);
  return JSON.parse(res);
}

/**
 * 批量替换对象属性名
 * @param { object } props { oldProp1: newProp1, oldProp2: newProp2 }
 */
util.replaceObpropMultiple = (ob, props) => {
  if (typeof ob !== 'object') {
    throw new Error('The paramter "object" is illegal');
  }
  if (typeof props !== 'object') {
    throw new Error('The paramter "props" is illegal');
  }

  for (let key in props) {
    util.replaceObprop(ob, key, props[key]);
  }
}


/**
 * 确定浏览器视图尺寸
 */
util.getViewport = () => {
  // 检查 document.compatMode 属性，以确定浏览器是否运行在混杂模式。
  // Safari3.1 之前的版本不支持这个属性，因此就会自动执行 else 语句
  if (document.compatMode == "BackCompat") {
    return {
      width: document.body.clientWidth,
      height: document.body.clientHeight
    };
  }
  return {
    width: document.documentElement.clientWidth,
    height: document.documentElement.clientHeight
  };

}

/**
 * 获取元素左侧距离父元素左侧距离
 */
util.getElementLeft = (element) => {
  var actualLeft = element.offsetLeft;
  var current = element.offsetParent;
  while (current !== null) {
    actualLeft += current.offsetLeft;
    current = current.offsetParent;
  }
  return actualLeft;
}

/**
 * 获取元素顶部距离父元素顶部距离
 * @param {*} element 
 */
util.getElementTop = (element) => {
  var actualTop = element.offsetTop;
  var current = element.offsetParent;
  while (current !== null) {
    actualTop += current.offsetTop;
    current = current.offsetParent;
  }
  return actualTop;
}

/**
 * 判断元素是否在界面中
 * @params { number } topHeight 符合条件：当元素在底部时，上半部暴露的高度
 * @params { number } bottomHeight 符合条件：当元素在顶部时，下半部暴露的高度
 */
util.isInViewPort = (el, topHeight = 0, bottomHeight = 0) => {
  const viewPortHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
  // const viewPortHeight = util.getViewport().height;
  const top = el.getBoundingClientRect() && el.getBoundingClientRect().top;
  return top <= viewPortHeight - topHeight && top > -bottomHeight;
}

util.debounce = (fn, wait) => {
  wait = wait || 0;
  var timerId;
  function debounced(...arg) {
    if (timerId) {
      window.clearTimeout(timerId);
      timerId = null;
    }
    timerId = window.setTimeout(function () {
      fn(...arg);
    }, wait);
  }
  return debounced;
}

/**
 * 将对象数组转化为对象
 * @param { array } array
 * @param { string } key 输出对象中的属性
 * @param { string } value 输出对象中的属性值
 * @example [{key: 'name', value: 'lirunkai'}] => { name: 'lirunkai }
 */
util.array2Ob = function (array, keyProp, valProp) {
  if (!Array.isArray(array)) {
    console.error('Function array2Ob parameters is illegal');
    return {};
  }
  const res = {};
  array.forEach(ele => {
    res[ele[keyProp]] = ele[valProp];
  })
  return res;
}


util.curry = function (fn) {
  const args = Array.prototype.slice.call(arguments, 1);
  return function () {
    const innerArgs = Array.prototype.slice.call(arguments);
    const totalArgs = args.concat(innerArgs);
    return fn(...totalArgs);
  }
}


util.formatNum = (num) => {
  let newStr = "";
  let count = 0;
  const numStr = String(num);

  for (var i = numStr.length - 1; i >= 0; i--) {
    if (count % 3 == 0 && count != 0) {
      newStr = numStr.charAt(i) + "," + newStr;
    } else {
      newStr = numStr.charAt(i) + newStr;
    }
    count++;
  }
  return newStr;
}

util.os = () => {
  const ua = window.navigator.userAgent,
    isWindowsPhone = /(?:Windows Phone)/.test(ua),
    isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
    isAndroid = /(?:Android)/.test(ua),
    isIOS = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent),
    isFireFox = /(?:Firefox)/.test(ua),
    isChrome = /(?:Chrome|CriOS)/.test(ua),
    isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
    isPhone = /(?:iPhone)/.test(ua) && !isTablet,
    isPc = !isPhone && !isAndroid && !isSymbian;
  return {
    isChrome,
    isFireFox,
    isTablet,
    isPhone,
    isAndroid,
    isPc,
    isIOS,
  };
};

util.isIE11 = () => {
  return /(trident)\/([\d.]+)/.test(window.navigator.userAgent.toLocaleLowerCase());
}


util.dataURL2blob = (dataURL) => {
  let binaryString = atob(dataURL.split(',')[1]);
  let arrayBuffer = new ArrayBuffer(binaryString.length);
  let intArray = new Uint8Array(arrayBuffer);
  let mime = dataURL.split(',')[0].match(/:(.*?);/)[1]
  for (let i = 0, j = binaryString.length; i < j; i++) {
    intArray[i] = binaryString.charCodeAt(i);
  }
  let data = [intArray];
  let result;
  try {
    result = new Blob(data, { type: mime });
  } catch (error) {
    window.BlobBuilder = window.BlobBuilder ||
      window.WebKitBlobBuilder ||
      window.MozBlobBuilder ||
      window.MSBlobBuilder;
    if (error.name === 'TypeError' && window.BlobBuilder) {
      var builder = new BlobBuilder();
      builder.append(arrayBuffer);
      result = builder.getBlob(type);
    } else {
      throw new Error('没救了');
    }
  }
  return result;
}

/**
 * dataUrl转objUrl
 */
util.dataURL2ObjUrl = (dataURL) => {
  window.URL = window.URL || window.webkitURL
  if (window.URL && URL.createObjectURL) {
    // dataURL2blob 此方法需额外定义
    var blob = util.dataURL2blob(dataURL)
    return URL.createObjectURL(blob)
  }
  return dataURL
}

util.isFirstView = function (id, user) {
  if (window === undefined) {
    throw new Error('window is undefined in Funtion isFirstView.');
  }
  if (typeof id !== 'string') {
    throw new Error('id is required.');
  }
  const IS_FIRST_VIEW = 'isFirstView-' + id + '-' + user;
  const now = new Date();
  const today = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate();
  const dateCache = window.localStorage.getItem(IS_FIRST_VIEW);	// isFirstView存储一个时间
  if (dateCache === null) {
    window.localStorage.setItem(IS_FIRST_VIEW, today);
    return true;
  }
  if (today !== dateCache) {
    window.localStorage.setItem(IS_FIRST_VIEW, today);
    return true;
  }
  return false;
}

/**
 * 判断是否超过缓存时间范围
 * @param {String} cacheKey 缓存标识(必填)
 * @param {Object} time 需要对比的时间(默认：当前时间)
 * @param {Mumber} range 时间范围(默认：0)
 */
util.overCacheTimeRange = function ({ cacheKey, time = new Date(), range = 0 }) {
  if (window === undefined) throw new Error('window is undefined in Funtion isFirstView.');

  const cacheTime = localStorage.getItem(cacheKey); // 缓存的值为字符串
  // 首次判断，缓存没值默认返回 true
  return (!cacheTime || ((time.getTime() - new Date(cacheTime).getTime()) >= range));
}

/**
 * 数组的findIndex方法，用于兼容ie11
 */
util.findIndex = function (array, fn) {
  if (!Array.prototype.findIndex) {
    let index = -1;
    for (let i = 0; i < array.length; i++) {
      if (fn(array[i], i) === true) {
        index = i;
      }
    }
    return index;
  }

  return array.findIndex(fn);
}

util.getPathParam = (pathname, param) => {
  const regExp = new RegExp('\\/' + param + '\\/([^\\/#\\?]+)($|\\/|#|\\?)');
  // const match = pathname.match(regExp);
  const match = regExp.exec(pathname);
  return match && match[1];
}

util.isPhone = () => {
  if (navigator) {
    const reg = /Android|iPhone|Windows Phone|iPod|MQQBrowser|OpenHarmony/i;
    return reg.test(navigator.userAgent);
  }
  console.error('未能获取到ua')
  return null;

}

/**
 * 格式化数字（逻辑：超过99，显示99+）
 * 
 */
util.formatCountLimite99 = function (num, overStr) {
  if (typeof num !== 'number') {
    return num;
  }
  if (num > 99) {
    return overStr || '99+';
  }
  return num;
}


util.formatTime = (value) => {
  let second = value || 0;
  let minute = 0;
  let hours = 0;

  if (value >= 60) {
    minute = value / 60;
    second = value % 60;
  }

  if (minute >= 60) {
    hours = minute / 60;
    minute = minute % 60;
  }

  const format = (num) => {
    const _num = Math.floor(num);
    return _num < 10 ? `0${_num}` : _num;
  }

  if (hours !== 0) {
    return `${format(hours)}:${format(minute)}:${format(second)}`;
  }
  return `${format(minute)}:${format(second)}`;
}
/**
 * 单例模式
 */
util.getSingle = (fn) => {
  let instance = null;
  return function () {
    const arg = Array.prototype.slice.call(arguments)
    return instance || (instance = new fn(...arg));
  }
}

/**
 * 获取课程的售卖类型
 * 
 * 试听时长 0: 非试听课-不提供试听 大于0：试听课-试听时长单位秒 -1：试听课-全部试听 -2:直播课-不提供试看
 */
util.getCourseStatus = (testCourseAuditionTime) => {
  if (testCourseAuditionTime === 0) {
    return COURSE_TYPE.NO_AUTION;
  }
  if (testCourseAuditionTime > 0) {
    return COURSE_TYPE.LIMIT_AUTION;
  }
  if (testCourseAuditionTime === -1) {
    return COURSE_TYPE.FULL_AUTION;
  }
  return null;
}


/**
 * 课程有无折扣价
 */
util.hasDiscount = function (discountPrice) {
  return discountPrice !== -1;
}

/**
 * 将时间距离（毫秒）转化为具体的时间（日、时、分、秒）
 */
util.msToDate = function (ms) {
  const DAY = 24 * 60 * 60 * 1000;
  const HOUR = 60 * 60 * 1000;
  const MINUTE = 60 * 1000;
  const SECOND = 1000;
  let day = Math.floor(ms / DAY);
  let hour = Math.floor((ms % DAY) / HOUR);
  let minute = Math.floor((ms % HOUR) / MINUTE);
  let second = Math.floor((ms % MINUTE) / SECOND);
  let milliSecond = Math.floor(ms % SECOND);
  return [
    day,
    hour,
    minute,
    second,
    milliSecond,
  ]
}

/**
 * 个位数数值前面补零
 */
util.singleDigitPadding = (num) => {
  if (num < 10) {
    return `0${num}`
  }
  return `${num}`;
}

/**
 * 动画
 * @param fn {fnc} 执行函数 返回true继续下一帧动画，返回false停止动画
 * @param interval 帧之间的时间间隔（毫秒）
 * @param finish 停止动画后的回调
 * @returns 动画实例（拥有clear方法用于清空动画）
 */
util.Animation = function Animation(fn, interval, finish) {
  if (!this instanceof Animation) {
    return new Animation();
  }

  this.animation = null;
  this.fn = fn;
  this.interval = interval;
  this.finish = finish;
  this.continiue = false;  // 是否继续


  this.start = () => {
    let lastTime = null;
    this.continiue = this.fn();
    function run(timestamp) {
      lastTime = lastTime || timestamp;
      const tickInterval = timestamp - lastTime;
      if (tickInterval >= this.interval) {
        this.continiue = this.fn();
        lastTime = timestamp + (tickInterval - this.interval);
      }

      if (this.continiue === undefined) {
        return;
      }

      if (this.continiue === true) {
        this.animation = window.requestAnimationFrame(run.bind(this));
        return;
      }
      if (this.continiue === false) {
        this.finish();
      }
    }

    this.animation = window.requestAnimationFrame(run.bind(this));
  }
  this.clear = () => {
    cancelAnimationFrame(this.animation);
  }
  this.clear();
  this.start();
}


/**
 * 倒计时
 * @param {number} endTime 结束时间(ms)
 * @param {number} interval 更新间隔(ms)
 * @param {function} update 更新回调
 * @param {function} finish 结束回调
 * @param {number} [now] 时间矫正（选填，建议传入服务端时间，避免用户本地时间不准确）
 * @function start 启动计时
 * @function clear 结束计时
 */
util.CountDown = function (endTime, interval, update, finish, now) {
  this._endTime = endTime;
  this._interval = interval;
  this._update = update;
  this._finish = finish;
  this._now = now || Date.now();
  this._current = 0;
  this._timer = null;

  const fromNow = Date.now() - this._now;
  this._current = this._endTime - (Date.now() - fromNow);
  this._update(this._current);
  this.start = () => {
    this._timer = setTimeout(() => {
      this._current = this._endTime - (Date.now() - fromNow);
      this._update(this._current);
      if (this._current > 0) {
        this.start();
      } else {
        !!this._finish && this._finish();
      }
    }, this._interval);
  }

  this.clear = () => {
    clearTimeout(this._timer);
  }

}

/*
 * HTML反转义
 * @param encodedText
 * @returns {string|*}
 * @constructor
 */
util.HTMLDecode = function (encodedText) {
  if (!encodedText) {
    return '';
  }
  let arrEntities = { 'lt': '<', 'gt': '>', 'nbsp': ' ', 'amp': '&', 'quot': '"', 'apos': `'` };
  return encodedText.replace(/&(lt|gt|nbsp|amp|quot|apos);/ig, function (all, t) {
    return arrEntities[t];
  });
}

util.HTMLEncode = function (decodedText) {
  if (!decodedText) {
    return '';
  }
  return decodedText.replace(/[<>&"]/g, function (c) {
    return { '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;' }[c];
  });
}

util.computeTimeDistance = function (preTime, now = new Date()) {
  var ONE_MINUTE = 60 * 1000;
  var ONE_HOUR = 60 * 60 * 1000;
  var ONE_DAY = 60 * 60 * 24 * 1000;
  var THREE_DAY = 60 * 60 * 24 * 3 * 1000;
  var offsetTime = now - preTime;

  if (0 <= offsetTime && offsetTime <= ONE_MINUTE) {
    return '刚刚';
  }

  if (ONE_MINUTE < offsetTime && offsetTime < ONE_HOUR) {
    var m = Math.round(offsetTime / ONE_MINUTE);
    return m + '分钟前';
  }

  if (ONE_HOUR <= offsetTime && offsetTime < ONE_DAY) {
    var h = Math.round(offsetTime / ONE_HOUR);
    return h + '小时前';
  }

  if (ONE_DAY <= offsetTime && offsetTime <= THREE_DAY) {
    var d = Math.round(offsetTime / ONE_DAY);
    if (1 <= d && d < 2) {
      return '昨天';
    }
    if (2 <= d && d <= 3) {
      return '前天'
    }
  }
  var isLastYear = new Date(preTime).getFullYear() !== new Date(now).getFullYear();

  if (THREE_DAY < offsetTime && !isLastYear) {
    var date = new Date(preTime);
    var month = date.getMonth() + 1;
    var day = date.getDate();
    return month + '-' + day;
  }

  if (THREE_DAY < offsetTime && isLastYear) {
    var date = new Date(preTime);
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var year = date.getFullYear().toString().slice(2);
    return year + '-' + month + '-' + day;
  }

  return '刚刚';
}

util.addUrlParam = function (url, key, value) {
  if (/^.*\?.+=.+$/.test(url)) {
    return `${url}&${key}=${value}`
  } else {
    return `${url}?${key}=${value}`
  }
};

/**
 * 获取一个设置查询参数的url
 */
util.getUrlWithParam = function (url, arg, arg_val) {
  var pattern = arg + '=([^&]*)';
  var replaceText = arg + '=' + arg_val;
  if (url.match(pattern)) {
    var tmp = '/(' + arg + '=)([^&]*)/gi';
    tmp = url.replace(eval(tmp), replaceText);
    return tmp;
  } else {
    if (url.match('[\?]')) {
      return url + '&' + replaceText;
    } else {
      return url + '?' + replaceText;
    }
  }
}

/**
 * 是否已经有该操作
 * @param {*} type 操作类型
 */
util.isFirstDoIt = function (type) {
  return new Promise((resolve, reject) => {
    axios.get(`/v1/users/options/isExist?type=${type}`)
      .then(res => {
        if (res.statusCode === 200) {
          resolve(res.data);
        } else {
          reject(res);
        }
      })
      .catch(err => {
        reject(err);
      });
  })
}

/**
 * 用户触发行为上报
 */
util.reportUserEvent = function (type) {
  return new Promise((resolve, reject) => {
    axios.post('/v1/users/events', {
      type
    }).then(res => {
      if (res.statusCode === 200) {
        resolve(res.data);
      } else {
        reject(res);
      }
    })
      .catch(err => {
        reject(err);
      });
  })
}

export default util;

// 字符串长度计算
export const countSymbols = val => {
  const regexAstralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]|\n/g;
  return val.replace(regexAstralSymbols, '_').length;
}

// 浮点数加法运算精度问题
export const floatAdd = (num1, num2) => {
  const num1Digits = (num1.toString().split('.')[1] || '').length;
  const num2Digits = (num2.toString().split('.')[1] || '').length;
  const baseNum = Math.pow(10, Math.max(num1Digits, num2Digits));
  return (num1 * baseNum + num2 * baseNum) / baseNum;
}

/**
 * 跳转微信支付
 * @param {string} type 支付类型，目前有课组支付(group)、商城支付(shop)
 * @param {string} orderUid 订单id，课组支付传递课组id
 * @param {string} successRedirect 支付成功跳转url
 * @param {string} failRedirect 支付失败跳转url（大多数情况为用户取消支付）
 */
export const getWcPayUrl = function (type, orderUid, successRedirect, failRedirect) {
  const { wechatPay, seewoEduUrl } = window.__INITIAL_STATE__
  let url = ''
  if (isWechat()) {
    // 微信浏览器
    let redirectUrl = `${seewoEduUrl}/pay/brandWCPay/${orderUid}?type=${type}&successRedirect=${successRedirect}&failRedirect=${failRedirect}`
    url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${wechatPay.appID}&redirect_uri=${encodeURIComponent(redirectUrl)}&response_type=code&scope=snsapi_base&state=#wechat_redirect`;
  } else {
    // 普通浏览器，调用H5支付
    url = `/pay/brandH5Pay/${orderUid}?type=${type}&successRedirect=${encodeURIComponent(successRedirect)}&failRedirect=${encodeURIComponent(failRedirect)}`;
  }

  location.href = url
}

// 判断是否在微信中打开
export const isWechat = function () {
  var ua = window.navigator.userAgent
  return ua.match(/MicroMessenger/i) == "MicroMessenger" && ua.match(/wxwork/i) != 'wxwork'
}

// 判断是否为正式环境
export const isPro = function () {
  return /seewoedu.cn/i.test(location.href)
}

/**
 * 对象转字符串(对象可为非JSON对象)
 * @param {object} o 含有任意属性值的对象（包括正则、函数等）
 */
export function obToStr(o) {
  function isNumber(obj) {
    return (typeof obj === 'number') && obj.constructor === Number;
  }
  function isString(str) {
    return (typeof str === 'string') && str.constructor === String;
  }

  function JSONstringify(tobj) {
    if (tobj instanceof Array) {
      return AtoJSON(tobj);
    }
    if (isString(tobj)) {
      return StoJSON(tobj);
    }
    if (tobj instanceof Function) {
      return tobj.toString();
    }
    if (tobj instanceof Boolean) {
      return tobj.toString();
    }
    if (isNumber(tobj)) {
      return tobj.toString();
    }
    if (tobj instanceof RegExp) {
      return tobj.toString();
    }
    if (tobj instanceof Date) {
      return tobj.toString();
    }
    if (tobj instanceof Object) {
      return OtoJSON(tobj);
    }
    return `"${tobj.toString()}"`;
  }

  function OtoJSON(obj) {
    const jsonOb = [];
    Object.keys(obj).forEach((i) => {
      jsonOb.push(
        `${JSONstringify(i)}:${((obj[i] != null) ? JSONstringify(obj[i]) : 'null')}`
      );
    });
    return `{${jsonOb.join(',')}}`;
  }
  // 数组转换为json str
  function AtoJSON(arr) {
    const jsonOb = [];
    const j = arr.length;
    for (let i = 0; i < j; i++) {
      jsonOb[i] = (arr[i] != null) ? JSONstringify(arr[i]) : 'null';
    }
    return `[${jsonOb.join(',')}]`;
  }
  // 字符串格式化并转换为json str
  function StoJSON(s) {
    // eslint-disable-next-line prefer-rest-params, no-nested-ternary, max-len
    return `"${s.replace(/(\\|\")/g, '\\$1').replace(/\n|\r|\t/g, function () { const a = arguments[0]; return (a === '\n') ? '\\n' : (a === '\r') ? '\\r' : (a === '\t') ? '\\t' : ''; })
      }"`;
  }
  return JSONstringify(o);
}

/**
 * 检查是否登陆(简单版)
 * @description 该方法不能完全保证当前为登录状态，如有该需求请使用checkLogin。
 * 该方法主要用于不要求登录状态准确性的场景，比如某个接口即使前端的登录状态不准确，后台也会判断
 * 该方法可用于性能优化，减少鉴权请求
 */
export function checkLoginSimply() {
  const isLogin = Cookies.get('isLogin')
  return isLogin === 'true';
}


// window.external && window.external.GetUserAgent()
// 判断是否为en5pc
export function isInEnPC() {
  let isEnPC = false
  try {
    if (window.CefSharp || (window.external && window.external.GetUserAgent && window.external.GetUserAgent())) {
      isEnPC = true
    }
  } catch (error) { }

  return isEnPC
}

/**
 * 数量四舍五入转换
 * @param {*} num 数值
 * @param {*} util1 过万单位
 * @param {*} util2 过亿单位
 */
export function parseFloat2mil(num, util1 = '万', util2 = '亿') {
  let number = parseInt(num || 0);
  if (number < 10000) {
    return number;
  } else if (number < 100000000) {
    number = number / 10000;
    // if (parseInt(number) === number) {
    //   return parseInt(number) + util1
    // }
    return number.toFixed(1) + util1;

  }
  number = number / 100000000;
  // if (parseInt(number) === number) {
  //   return parseInt(number) + util2
  // }
  return number.toFixed(1) + util2;


}
//  下载图片功能，目前应用于en5pc
export function downloadByBlob(url, name, callback) {
  let image = new Image()
  image.setAttribute('crossOrigin', 'anonymous')
  image.src = url
  image.onload = () => {
    let canvas = document.createElement('canvas')
    canvas.width = image.width
    canvas.height = image.height
    let ctx = canvas.getContext('2d')
    ctx.drawImage(image, 0, 0, image.width, image.height)
    canvas.toBlob((blob) => {
      let url = URL.createObjectURL(blob)
      download(url, name)
      // 用完释放URL对象
      URL.revokeObjectURL(url)
      callback()
    })
  }
}
function download(href, name = 'pic') {
  let eleLink = document.createElement('a')
  eleLink.download = name
  eleLink.href = href
  eleLink.click()
  eleLink.remove()
}

// 获取服务器时间
export const getCurrentTime = () => {
  return axios.get(`/getTime`);
};

// 获取今天零点的时间戳
export const getTodayZeroTime = () => {
  let time = new Date(new Date().toLocaleDateString()).getTime();
  if (!time) {
    time = new Date(new Date().setHours(0, 0, 0, 0)).getTime();
  }
  return time;
};

// 十以内的数字转中文，后面有需要再继续拓展
export const numb2text = (numb) => {
  const numb2textList = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];
  const text = numb2textList[numb];
  // 不在范围内，原样返回
  if (!text) {
    return numb;
  }
  return text;
};
// 查询用户是否有某次操作记录
export const getOptionRecord = (type) => {
  return new Promise((resolve, reject) => {
    axios.get(`/v1/users/options/isExist?type=${type}`)
      .then((r) => {
        if (r.statusCode == 200) {
          resolve(r.data);
        } else {
          reject(r);
        }
      })
      .catch((e) => {
        reject(e);
      });
  });
}

// 提交用户是否有某次操作记录
export const postOptionRecord = (type) => {
  return new Promise((resolve, reject) => {
    axios.post(`/v1/users/options/add?type=${type}`)
      .then((r) => {
        resolve(r);
      })
      .catch((e) => {
        reject(e);
      });
  });
}

// 获取IP的地理位置
export function getIpGeographic() {
  return new Promise((resolve, reject) => {
    axios
      .get('/ip/geographic')
      .then((r) => {
        resolve(r);
      })
      .catch((e) => {
        reject(e);
      });
  });
}

// 获取用户基本信息
export function getUserInfo() {
  return new Promise((resolve, reject) => {
    axios
      .get('/getUserInfo')
      .then((res) => {
        if (res && res.user_info) {
          resolve(res.user_info);
        } else {
          reject(res);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}

// 校验银行卡
export function luhnCheck(bankno) {
  var lastNum = bankno.substr(bankno.length - 1, 1);// 取出最后一位（与luhn进行比较）
  var first15Num = bankno.substr(0, bankno.length - 1);// 前15或18位
  var newArr = new Array();
  for (var i = first15Num.length - 1; i > -1; i--) { // 前15或18位倒序存进数组
    newArr.push(first15Num.substr(i, 1));
  }
  var arrJiShu = new Array(); // 奇数位*2的积 <9
  var arrJiShu2 = new Array(); // 奇数位*2的积 >9
  var arrOuShu = new Array(); // 偶数位数组
  for (var j = 0; j < newArr.length; j++) {
    if ((j + 1) % 2 == 1) {// 奇数位
      if (parseInt(newArr[j]) * 2 < 9) {
        arrJiShu.push(parseInt(newArr[j]) * 2);
      } else {
        arrJiShu2.push(parseInt(newArr[j]) * 2);
      }
    } else {
      arrOuShu.push(newArr[j]);// 偶数位
    }
  }

  var jishu_child1 = new Array();// 奇数位*2 >9 的分割之后的数组个位数
  var jishu_child2 = new Array();// 奇数位*2 >9 的分割之后的数组十位数
  for (var h = 0; h < arrJiShu2.length; h++) {
    jishu_child1.push(parseInt(arrJiShu2[h]) % 10);
    jishu_child2.push(parseInt(arrJiShu2[h]) / 10);
  }
  var sumJiShu = 0; // 奇数位*2 < 9 的数组之和
  var sumOuShu = 0; // 偶数位数组之和
  var sumJiShuChild1 = 0; // 奇数位*2 >9 的分割之后的数组个位数之和
  var sumJiShuChild2 = 0; // 奇数位*2 >9 的分割之后的数组十位数之和
  var sumTotal = 0;
  for (var m = 0; m < arrJiShu.length; m++) {
    sumJiShu = sumJiShu + parseInt(arrJiShu[m]);
  }
  for (var n = 0; n < arrOuShu.length; n++) {
    sumOuShu = sumOuShu + parseInt(arrOuShu[n]);
  }
  for (var p = 0; p < jishu_child1.length; p++) {
    sumJiShuChild1 = sumJiShuChild1 + parseInt(jishu_child1[p]);
    sumJiShuChild2 = sumJiShuChild2 + parseInt(jishu_child2[p]);
  }
  // 计算总和
  sumTotal = parseInt(sumJiShu) + parseInt(sumOuShu)
    + parseInt(sumJiShuChild1) + parseInt(sumJiShuChild2);
  // 计算luhn值
  var k = parseInt(sumTotal) % 10 == 0 ? 10 : parseInt(sumTotal) % 10;
  var luhn = 10 - k;
  if (lastNum == luhn) {
    return true;
  } else {
    return false;
  }
}

// 端的判断
export function isPhone() {
  const reg = /Android|iPhone|Windows Phone|iPod|MQQBrowser|OpenHarmony/i;
  return reg.test(navigator.userAgent);
}

// 用于快速验证摇树优化，对业务功能没有任何影响，请不要删除
export function aaaaa() {
  console.log("aaaaaa");
  return 'bbbbb'
}

/**
 * 通过后台响应判断登陆跳转
 */
export function checkLoginAndRedirect(resp) {
  if (resp.statusCode === 40000 || resp.statusCode === 40106) {
    PageJump.redirectLogin();
    return false;
  }
  return true;
}